var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _path5, _path6, _path7, _rect4, _rect5, _rect6, _rect7, _path8, _path9, _path10, _circle, _path11, _circle2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpdated(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 600,
    viewBox: "0 0 900 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M0 0h900v600H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M579.031 140.012v343.549c0 25.06-20.206 45.68-45.464 45.68h-14.838c-9.156 0-16.733-5.076-23.048-11.737-10.102-11.103-15.47-25.695-15.47-40.922V436.93c0-15.861-12.944-28.867-28.73-28.867-100.957 0-182.8-81.842-182.8-182.8v-85.251c0-14.275 11.682-26.012 25.889-26.012h258.572c14.523 0 25.889 11.737 25.889 26.012z",
    fill: "url(#a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M529.229 493.621H185.68c-25.061 0-45.68-20.347-45.68-45.78v-14.942c0-9.22 5.075-16.85 11.737-23.208 11.103-10.174 25.695-15.578 40.921-15.578h39.653c15.861 0 28.867-13.035 28.867-28.93 0-101.662 82.412-184.074 184.074-184.074h83.977c14.274 0 26.012 11.763 26.012 26.069v260.374a25.955 25.955 0 0 1-26.012 26.069z",
    fill: "url(#b)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M585 248.515v125.668c0 9.166 7.468 16.709 16.804 16.709h5.484c3.385 0 6.185-1.857 8.519-4.294 3.734-4.061 5.718-9.398 5.718-14.968v-14.505c0-5.802 4.785-10.559 10.619-10.559 37.316 0 67.566-30.25 67.566-67.566v-30.485c0-5.222-4.318-9.515-9.569-9.515h-95.572c-5.368 0-9.569 4.293-9.569 9.515z",
    fill: "url(#c)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 297.878,
    y: 154.01,
    width: 251.956,
    height: 21.627,
    rx: 10.814,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 297.878,
    y: 197.265,
    width: 156.797,
    height: 21.627,
    rx: 10.814,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 297.878,
    y: 240.519,
    width: 156.797,
    height: 22.709,
    rx: 11.354,
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m182.714 343.312 11.354-10.813-11.354-10.814-11.355 10.814 11.355 10.813z",
    stroke: "#E1E4E5",
    strokeWidth: 5.861,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M746.722 256.861c0 6.002-4.864 10.861-10.873 10.861-6.009 0-10.849-4.883-10.849-10.861 0-6.002 4.864-10.861 10.873-10.861 6.009 0 10.849 4.859 10.849 10.861z",
    stroke: "#E1E4E5",
    strokeWidth: 3.879,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M661.863 270.916c0 7.69-6.463 13.916-14.447 13.916-7.984 0-14.416-6.256-14.416-13.916 0-7.69 6.463-13.916 14.447-13.916 7.984 0 14.416 6.226 14.416 13.916z",
    stroke: "#E1E4E5",
    strokeWidth: 5.154,
    strokeMiterlimit: 10
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 644,
    y: 191.794,
    width: 37.892,
    height: 4.415,
    rx: 2.207,
    transform: "rotate(-45 644 191.794)",
    fill: "#E1E4E5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 658.528,
    y: 191.897,
    width: 14.069,
    height: 4.415,
    rx: 2.207,
    transform: "rotate(-45 658.528 191.897)",
    fill: "#E1E4E5"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 274.047,
    width: 40.778,
    height: 4.751,
    rx: 2.375,
    transform: "rotate(-45 206 274.047)",
    fill: "#E1E4E5"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 221.635,
    y: 274.159,
    width: 15.141,
    height: 4.751,
    rx: 2.375,
    transform: "rotate(-45 221.635 274.159)",
    fill: "#E1E4E5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M340.774 265.779c-55.913 7.639-99.127 55.102-99.127 113.141 0 63.338 51.329 114.701 114.624 114.701h252.172c50.641 0 91.699-41.086 91.699-91.761s-41.058-91.761-91.699-91.761c0-76.024-61.575-137.641-137.548-137.641-60.453 0-111.667 39.067-130.121 93.321z",
    fill: "#facc15"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m524.963 367.102-54.068 54.067-54.068-54.067m54.068-92.997v142.739",
    stroke: "#fff",
    strokeWidth: 24.979,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M198.997 459.019c11.13-1.041 21.728-11.616 21.728-11.616s-12.567-10.451-23.698-9.411c-11.13 1.041-19.718 6.59-19.174 12.4.545 5.809 10.007 9.671 21.144 8.627z",
    fill: "#E1E4E5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 608.262,
    cy: 172.262,
    r: 12.029,
    transform: "rotate(-178.879 608.262 172.262)",
    fill: "#E1E4E5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M219.627 187.687c7.765-5.539 20.506-4.627 20.506-4.627s-2.28 13.759-10.045 19.298c-7.765 5.538-16.405 6.748-19.294 2.695-2.89-4.054 1.062-11.826 8.833-17.366z",
    fill: "#E1E4E5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 9.872,
    transform: "scale(1 -1) rotate(-43.879 -57.292 -1064.656)",
    fill: "#E1E4E5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 430.473,
    y1: 762.049,
    x2: 413.344,
    y2: -337.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -92.808,
    y1: 344.028,
    x2: 1006.84,
    y2: 327.017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 639.909,
    y1: 476.051,
    x2: 646.11,
    y2: 73.809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdated);
export default __webpack_public_path__ + "static/media/updated.d41480590561223e00fbc4b307b9baf6.svg";
export { ForwardRef as ReactComponent };